import { useEffect, useRef, useState } from 'react'

import { DSToastContainer, DSAlert } from '@vr/ds-react'

import { FormFilter } from '@/compositions/form-filters-general'
import { FormFilterRef } from '@/compositions/form-filters-general/ref'
import { OperatorsList } from '@/compositions/operators-list'
import { useGeneralContext } from '@/contexts/general.context'

const GeneralView = () => {
  const filterFormRef = useRef<FormFilterRef>(null)
  const [rejectedCount, setRejectedCount] = useState(0)

  const { tableData, setTableData, handleFilter, setPage, setResults, handleLimitChange, limit } = useGeneralContext()

  useEffect(() => {
    const total = getRejectedCount()
    setRejectedCount(total)
  }, [tableData])

  const getRejectedCount = () => {
    return tableData?.filter(item => item.status === 'recusado').length ?? 0
  }

  const handleClearForm = () => {
    if (filterFormRef.current) {
      filterFormRef.current.clearForm()
      setTableData([])
      setResults(0)
      setPage(1)
      handleLimitChange(10)
    }
  }

  return (
    <>
      {rejectedCount > 0 && (
        <DSAlert
          type='error'
          title={`${rejectedCount} ite${rejectedCount > 1 ? 'ns' : 'm'} fo${
            rejectedCount > 1 ? 'ram' : 'i'
          } recusado${rejectedCount > 1 ? 's' : ''}`}
          css={{ marginBottom: '$sm16' }}
        >
          Inicie uma nova solicitação de logística para os itens
        </DSAlert>
      )}

      <DSToastContainer position='top-left' />
      <FormFilter
        ref={filterFormRef}
        onFilters={handleFilter}
        onClear={handleClearForm}
        limit={limit}
        onLimitChange={handleLimitChange}
      />

      <OperatorsList />
    </>
  )
}

export default GeneralView
